import { STANDARD_BRANCH } from '@festina-life/api'

import { DraftIndicator } from '../../components/draftIndicator/DraftIndicator'
import { OperationApproval } from '../../components/operationApproval/OperationApproval'
import { OperationViewerTopBar } from '../../components/operationViewerTopBar/OperationViewerTopBar'
import { useIsInlineEditingAvailable } from '../../hooks/useIsInlineEditingAvailable'
import { useNavigationParams } from '../../system/useNavigationParams'
import type { IndexedGlMapOperationWithMetaData } from '../../uiModels/glMapOperations/types'
import { GlMapDownloadVersionButton } from './GlMapDownloadVersionButton'
import { GlMapTransferButton } from './GlMapTransferButton'
import { GlMapUploadVersionButton } from './GlMapUploadVersionButton'

type Props = {
  /** Version in scope, if any exists at the current view date. */
  glMapOperation: IndexedGlMapOperationWithMetaData
}

/**
 * TopBar used to identify the GL-map version in scope and to host its operation
 * management controls, such as approval, download, upload and transfer.
 */
export const GlMapViewerTopBar = ({ glMapOperation }: Props) => {
  const isInlineEditingAvailable = useIsInlineEditingAvailable()
  const { branch } = useNavigationParams()
  const changesetKey = glMapOperation.changesetHistory?.changesetKey
  const operationKey = glMapOperation.internalOperation.operationKey
  const isRenderingApproval =
    !glMapOperation.isDraft &&
    branch !== STANDARD_BRANCH &&
    !!changesetKey &&
    !!operationKey

  return (
    <OperationViewerTopBar className="justify-end gap-x-2">
      {glMapOperation.isDraft && <DraftIndicator />}
      {isRenderingApproval && (
        <OperationApproval
          actions={glMapOperation.actions ?? []}
          changesetKey={changesetKey}
          operationKey={operationKey}
        />
      )}
      <GlMapDownloadVersionButton glMapOperation={glMapOperation} />
      {isInlineEditingAvailable && <GlMapUploadVersionButton />}
      <GlMapTransferButton />
    </OperationViewerTopBar>
  )
}
